import * as Yup from "yup";

export const verificationFormInputArr2 = [
  /* ================= STEP 1 ================= */
  {
    arr: [
      {
        field: "from_name",
      },
      {
        field: "from_address",
      },
      {
        field: "lender_title",
      },
      {
        field: "lender_number",
      },
    ],
  },

  /* ================= STEP 2 ================= */
  {
    arr: [
      {
        field: "property_street",
      },
      {
        field: "property_city",
      },
      {
        field: "property_state",
      },
      {
        field: "property_zip",
      },
      {
        field: "account_name",
      },
      {
        field: "account_number",
      },
      { field: "loan_property" },
    ],
  },

  /* ================= STEP 3 ================= */
  {
    arr: [
      {
        field: "applicant_name",
      },
      {
        field: "borrower_signature",
      },
    ],
  },
];

// export const verificationFormInputArr = (display, states) => [
//   {
//     field: "lenderInformation",
//     className: "row",
//     arr: [
//       {
//         section: "",
//         className: "col-6",
//         arr: [
//           {
//             title: "1. TO (Name of Landlord/Creditor)",
//             field: "to_name",
//             type: "text",
//             className: "col-12",
//             disable: true,
//             defaultValue: "Superior Loan Servicing",
//           },

//           // {
//           //   title: "To (Address of Landlord/Creditor)",
//           //   field: "to_address",
//           //   type: "textarea",
//           //   className: "col-12",
//           //   rows: 3,
//           //   placeholder: "Enter full address",
//           //   disable: true,
//           //   defaultValue:
//           //     "28348 Roadside Dr. 1st Floor\nAgoura Hills, CA 91301",
//           // },
//           {
//             title: "TO (Street of Landlord/Creditor)",
//             field: "to_street",
//             type: "textarea",
//             className: "col-6",
//             disable: true,
//             rows: 4,
//           },
//           {
//             title: "TO (City of Landlord/Creditor)",
//             field: "to_city",
//             type: "text",
//             disable: true,
//             className: "col-6",
//           },
//           {
//             title: "TO (State of Landlord/Creditor)",
//             field: "to_state",
//             type: "text",
//             disable: true,
//             className: "col-6",
//           },
//           {
//             title: "TO (ZipCode of Landlord/Creditor)",
//             field: "to_zipcode",
//             type: "text",
//             disable: true,
//             className: "col-6",
//           },
//         ],
//       },
//       {
//         section: "",
//         className: "col-6",
//         arr: [
//           {
//             title: "2. FROM (Name of Lender)",
//             field: "from_name",
//             type: "text",
//             className: "col-12",
//           },
//           // {
//           //   title: "FROM (Address of Lender)",
//           //   field: "from_address",
//           //   type: "textarea",
//           //   className: "col-6",
//           //   rows: 3,
//           //   placeholder: "Enter full address",
//           // },
//           {
//             title: "FROM (Street of Lender)",
//             field: "from_street",
//             type: "textarea",
//             className: "col-6",
//             rows: 3,
//           },
//           {
//             title: "FROM (City of Lender)",
//             field: "from_city",
//             type: "text",
//             className: "col-6",
//           },
//           {
//             title: "FROM (State of Lender)",
//             field: "from_state",
//             type: "select",
//             className: "col-6 text-start",
//             options: states
//           },
//           {
//             title: "FROM (ZipCode of Lender)",
//             field: "from_zipcode",
//             type: "text",
//             className: "col-6",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     field: "lenderDetails",
//     arr: [
//       {
//         section: "",
//         className: "",
//         arr: [
//           {
//             title: "3. SIGNATURE OF LENDER",
//             field: "lender_signature",
//             type: "sign",
//             className: "col-3",
//           },
//           {
//             title: "4. TITLE",
//             field: "lender_title",
//             type: "text",
//             className: "col-3",
//           },
//           {
//             title: "5. DATE",
//             field: "lender_date",
//             type: "date",
//             className: "col-3",
//             disable: true,
//           },
//           {
//             title: "6. LENDER'S NUMBER",
//             field: "lender_number",
//             type: "phoneNumber",
//             className: "col-3",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     field: "verificationInformation",
//     arr: [
//       {
//         section: "",
//         className: "",
//         arr: [
//           {
//             type: "content",
//             content: (
//               <div className="mb-2">
//                 <p className="fw-bold mb-2 bg-primary text-white p-4 mb-4">
//                   Property Details
//                 </p>
//                 <div className="d-flex align-items-center">
//                   <span className="fw-bold me-3">☑ MORTGAGE</span>
//                   <span className="text-muted small">(Type)</span>
//                 </div>
//               </div>
//             ),
//             className: "col-12",
//           },
//           {
//             title: "Property Address - Street",
//             field: "property_street",
//             type: "text",
//             className: "col-3",
//           },
//           {
//             title: "City",
//             field: "property_city",
//             type: "text",
//             className: "col-3",
//           },
//           {
//             title: "State",
//             field: "property_state",
//             type: "select",
//             className: "col-3 text-start",
//             options: states
//           },
//           {
//             title: "Zip Code",
//             field: "property_zip",
//             type: "text",
//             className: "col-3",
//           },
//           {
//             title: "Account in the name of (Borrower):",
//             field: "account_name",
//             type: "text",
//             className: "col-6",
//           },
//           {
//             title: "Loan Account No.",
//             field: "account_number",
//             type: "text",
//             className: "col-6",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     field: "applicantInformation",
//     arr: [
//       // {
//       //   section: "Applicant Info",
//       //   className: "",
//       //   arr: [
//       //     {
//       //       title: "8. NAME OF APPLICANT",
//       //       field: "applicant_name",
//       //       type: "text",
//       //       className: "col-6",
//       //     },
//       //     {
//       //       title: "9. City OF APPLICANT",
//       //       field: "applicant_city",
//       //       type: "text",
//       //       className: "col-6",
//       //     },
//       //   ],
//       // },
//       {
//         section: "",
//         className: "col-12",
//         arr: [
//           {
//             type: "content",
//             content: (
//               <div className="mb-2">
//                 <p className="fw-bold mb-2 bg-primary text-white p-4">
//                   Applicant Info
//                 </p>
//               </div>
//             ),
//             className: "col-12",
//           },
//           {
//             title: "Name of Applicant",
//             field: "applicant_name",
//             type: "text",
//             className: "col-6",
//             rows: 4,
//           },
//           {
//             title: "Signature of Applicant",
//             field: "applicant_signature",
//             type: "sign",
//             className: "col-6",
//           },
//           {
//             title: "Do you have borrower's signature?",
//             field: "borrower_sign_available",
//             type: "checkbox",
//             className: "col-4 d-flex mt-3",
//           },
//           {
//             title: "Borrower's Authorization",
//             field: "borrower_signature",
//             type: "file",
//             className: "col-12",
//             display: display ? "" : "hidden",
//             isbase64: true
//           },
//           // {
//           //   title: "Street of Applicant",
//           //   field: "applicant_street",
//           //   type: "textarea",
//           //   className: "col-6",
//           //   rows: 4,
//           // },
//           // {
//           //   title: "City of Applicant",
//           //   field: "applicant_city",
//           //   type: "text",
//           //   className: "col-4",
//           // },
//           // {
//           //   title: "State of Applicant",
//           //   field: "applicant_state",
//           //   type: "text",
//           //   className: "col-4",
//           // },
//           // {
//           //   title: "ZipCode of Applicant",
//           //   field: "applicant_zipcode",
//           //   type: "text",
//           //   className: "col-4",
//           // },
//         ],
//       },
//     ],
//   },
// ];

export const verificationFormInputArr = (display, states, invalidError) => [
  {
    field: "lenderInformation",
    className: "row",
    arr: [
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "To (Name and Address of Landlord/Creditor)",
            field: "to_name",
            type: "textarea",
            className: "col-12",
            disable: true,
            rows: 3,
            // defaultValue: "Superior Loan Servicing",
          },

          // {
          //   title: "To (Address of Landlord/Creditor)",
          //   field: "to_address",
          //   type: "text",
          //   className: "col-6",
          //   placeholder: "Enter full address",
          //   disable: true,
          //   defaultValue:
          //     "28348 Roadside Dr. 1st Floor - Agoura Hills, CA 91301",
          // },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "From (Name of Lender)",
            field: "from_name",
            type: "text",
            className: "col-6",
          },
          {
            title: "From (Address of Lender)",
            field: "from_address",
            type: "textarea",
            className: "col-6",
            rows: 2,
            placeholder: "Enter full address",
          },
          // {
          //   title: "From (Street of Lender)",
          //   field: "from_street",
          //   type: "text",
          //   className: "col-3",
          //   rows: 3,
          // },
          // {
          //   title: "From (City of Lender)",
          //   field: "from_city",
          //   type: "text",
          //   className: "col-3",
          // },
          // {
          //   title: "From (State of Lender)",
          //   field: "from_state",
          //   type: "select",
          //   className: "col-3 text-start",
          //   options: states,
          //   blur: true,
          // },

          // {
          //   title: "Title",
          //   field: "lender_title",
          //   type: "text",
          //   className: "col-3",
          // },
          // {
          //   title: "From (ZipCode of Lender)",
          //   field: "from_zipcode",
          //   type: "text",
          //   className: "col-3",
          // },
        ],
      },
    ],
  },
  {
    field: "lenderDetails",
    className: "row",
    arr: [
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Title",
            field: "lender_title",
            type: "select",
            className: "col-md-4 col-sm-12 text-start",
            options: [
              { label: "Lender", value: "Lender" },
              { label: "Broker", value: "Broker" },
            ],
          },

          {
            title: "Lender's Number",
            field: "lender_number",
            type: "phoneNumber",
            className: "col-md-4 col-sm-12",
          },
          {
            title: "Signature of Lender",
            field: "lender_signature",
            type: "sign",
            className: "col-md-4 col-sm-12",
          },
        ],
      },
    ],
  },
  {
    field: "verificationInformation",
    className: "row",
    arr: [
      {
        section: "",
        className: "",
        arr: [
          {
            type: "content",
            content: (
              <div className="mb-2">
                <p className="fw-bold mb-2 bg-primary text-white p-4">
                  Property Details
                </p>
                <small className="text-muted">
                  <b>Note:</b> Please enter one of the following: complete
                  property address or loan account number.
                </small>
                {/* <div className="d-flex align-items-center">
                  <span className="fw-bold me-3">☑ MORTGAGE</span>
                  <span className="text-muted small">(Type)</span>
                </div> */}
              </div>
            ),
            className: "col-12",
          },
          {
            title: "Property Address - Street",
            field: "property_street",
            type: "text",
            className: "col-4",
          },
          {
            title: "City",
            field: "property_city",
            type: "text",
            className: "col-4",
          },
          {
            title: "State",
            field: "property_state",
            type: "select",
            className: "col-4 text-start",
            options: states,
            blur: true,
          },
          {
            title: "Zip Code",
            field: "property_zip",
            type: "text",
            className: "col-4",
          },
          {
            title: "Account in the name of (Borrower):",
            field: "account_name",
            type: "text",
            className: "col-4",
          },
          {
            title: "Loan Account Number",
            field: "account_number",
            type: "text",
            className: "col-4",
          },
          {
            type: "content",
            content: <p className="text-error">{invalidError}</p>,
            display: invalidError?.length ? "" : "hidden",
          },
        ],
      },
    ],
  },
  {
    field: "applicantInformation",
    className: "row",
    arr: [
      // {
      //   section: "Applicant Info",
      //   className: "",
      //   arr: [
      //     {
      //       title: "8. NAME OF APPLICANT",
      //       field: "applicant_name",
      //       type: "text",
      //       className: "col-6",
      //     },
      //     {
      //       title: "9. City OF APPLICANT",
      //       field: "applicant_city",
      //       type: "text",
      //       className: "col-6",
      //     },
      //   ],
      // },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            type: "content",
            content: (
              <div className="mb-2">
                <p className="fw-bold mb-2 bg-primary text-white p-4">
                  Applicant Info
                </p>
              </div>
            ),
            className: "col-12",
          },
          {
            title: "Name of Applicant",
            field: "applicant_name",
            type: "text",
            className: "col-6",
          },
          {
            title: "Signature of Applicant",
            field: "applicant_signature",
            type: "sign",
            className: "col-6",
          },
          {
            title:
              "Please upload the borrower’s authorization if available. If the authorization is not provided, a notification will be sent to the borrower requesting their signature for the pending VOM request.",
            field: "borrower_sign_available",
            type: "checkbox",
            className: "col-12 mt-3 text-start text-muted fw-bold",
          },
          {
            title: "Borrower's Authorization",
            field: "borrower_signature",
            type: "file",
            className: "col-12",
            display: display ? "" : "hidden",
            isbase64: true,
            accept: "application/pdf",
          },
          // {
          //   title: "Street of Applicant",
          //   field: "applicant_street",
          //   type: "textarea",
          //   className: "col-6",
          //   rows: 4,
          // },
          // {
          //   title: "City of Applicant",
          //   field: "applicant_city",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "State of Applicant",
          //   field: "applicant_state",
          //   type: "text",
          //   className: "col-4",
          // },
          // {
          //   title: "ZipCode of Applicant",
          //   field: "applicant_zipcode",
          //   type: "text",
          //   className: "col-4",
          // },
        ],
      },
    ],
  },
];

export const verificationFormSchema = (isValidAccount) => {
  return Yup.object().shape({
    to_name: Yup.string(),
    to_street: Yup.string(),
    to_city: Yup.string(),
    to_state: Yup.string(),
    to_zipcode: Yup.string(),

    from_name: Yup.string().required("Lender Name is required"),
    from_address: Yup.string().required("Lender address is required"),
    // from_street: Yup.string().required("Lender street address is required"),
    // from_city: Yup.string().required("Lender city is required"),
    // from_state: Yup.string().required("Lender state is required"),
    // from_zipcode: Yup.string().required("Lender zipcode is required"),

    lender_signature: Yup.string(),
    lender_title: Yup.string().required("Title is required"),
    lender_number: Yup.string().required("Lender Number is required"),

    // 🔽 Make property fields optional individually
    borrower_email: Yup.string(),
    remarks: Yup.string(),
    property_street: Yup.string().nullable(),
    property_city: Yup.string().nullable(),
    property_state: Yup.string().nullable(),
    property_zip: Yup.string().nullable(),

    account_name: Yup.string(),
    account_number: Yup.string().nullable(),

    applicant_name: Yup.string(),
    borrower_mailing_address: Yup.string().required("Mailing address is required"),
    loan_property: Yup.string(),
    borrower_sign_available: Yup.boolean(),

    borrower_signature: Yup.mixed().when("borrower_sign_available", {
      is: true,
      then: (schema) =>
        schema.required("Please upload borrower's authorization"),
    }),

    // borrower_signature: Yup.string().when("borrower_sign_available", {
    //   is: true,
    //   then: (schema) =>
    //     schema.required("Please upload borrower's authorization"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
  });
  // .test(
  //   "property-or-account",
  //   "Either complete property address or loan account number is required",
  //   function (values) {
  //     const {
  //       property_street,
  //       property_city,
  //       property_state,
  //       property_zip,
  //       account_number,
  //     } = values;

  //     const hasCompletePropertyAddress =
  //       !!property_street &&
  //       !!property_city &&
  //       !!property_state &&
  //       !!property_zip;

  //     const hasAccountNumber = !!account_number;

  //     if (hasCompletePropertyAddress || isValidAccount) {
  //       return true;
  //     }

  //     // 👇 IMPORTANT PART
  //     return this.createError({
  //       path: "loan_property", // 👈 attach error to a real field
  //       message:
  //         "Either complete property address or vaild loan account number is required!",
  //     });
  //   },
  // );
};

export const findPropertySchema = (noPropertyFound) => {
  return Yup.object().shape({
    street: Yup.string().required("Street address is required"),
    city: Yup.string().nullable(),
    state: Yup.string().required("State is required"),
    zipcode: Yup.string().required("Zip Code is required"),
    // ...(noPropertyFound && {
    //   borrower_email: Yup.string().required("Borrower Email is required"),
    // }),
  });
};
